export default "<div class=\"health\">\n  <div class=\"health__content\">\n      {{ version }}\n  </div>    \n</div>";